// Ernährungsberater-Tool runtime — auto-generated, do not edit.
// Regenerate with `node cli.js deploy` from ~/projects/actinovo-ernaehrungsberater-tool/
"use strict";
'use strict';

/* ============ GA4 Custom Events (instrumentiert von Anfang an) ============ */
function track(name, params) {
  try {
    if (window.gtag) window.gtag('event', name, params || {});
    if (window.dataLayer) window.dataLayer.push({ event: name, ...(params || {}) });
  } catch (e) {}
}

/* ============ DATA Loading ============ */
let DATA = null;
async function loadData() { DATA = {
  "_meta": {
    "version": "1.0.0",
    "compiled": "2026-06-12",
    "scope": "Mikronährstoff-Beratung · Frauen-Lebenszyklus + Adipositas-Sidekick · für DGE/VDOE/VDD-zertifizierte Ernährungsberater:innen + IHK-Coaches",
    "disclaimer": "Beratungsempfehlung auf Basis öffentlicher Leitlinien. Ersetzt keine individuelle ärztliche Diagnostik. Therapeutische Substitution bei Diagnose erfordert Laborkontrolle und ärztliche Verordnung. NICHT geeignet für §20-SGB-V-geförderte Präventionskurse (GKV-Leitfaden Prävention verbietet NEM-Empfehlungen im Förderkanal)."
  },
  "sources": [
    { "label": "DGE D-A-CH Referenzwerte 2024",                       "url": "https://www.dge.de/wissenschaft/referenzwerte/" },
    { "label": "DGE Handlungsempfehlungen Schwangerschaft (Gesund ins Leben)", "url": "https://www.dge.de/gesunde-ernaehrung/gezielte-ernaehrung/ernaehrung-in-schwangerschaft-und-stillzeit/handlungsempfehlungen-ernaehrung-in-der-schwangerschaft/" },
    { "label": "BfR – Jod, Folat/Folsäure und Schwangerschaft",       "url": "https://www.bfr.bund.de/cm/350/jod-folat-folsaeure-und-schwangerschaft.pdf" },
    { "label": "AWMF S1-LL 025/021 Eisenmangelanämie (2021)",         "url": "https://register.awmf.org/assets/guidelines/025-021l_S1_Eisenmangelanaemie_2021-11.pdf" },
    { "label": "OEGGG/AGG Empfehlungen Eisenmangelanämie SS",          "url": "https://oeggg.at/wp-content/uploads/2022/08/Eisenpaper-OEGGG-GebFrau.pdf" },
    { "label": "AWMF S3-LL Gestationsdiabetes 057-008",                "url": "https://register.awmf.org/de/leitlinien/detail/057-008" },
    { "label": "AWMF S3-LL Adipositas — Prävention und Therapie 050-001", "url": "https://register.awmf.org/de/leitlinien/detail/050-001" },
    { "label": "AWMF S3-LL Chirurgie der Adipositas 088-001",          "url": "https://register.awmf.org/de/leitlinien/detail/088-001" },
    { "label": "DGE Positionspapier Vegane Ernährung 2024 (Neubewertung)", "url": "https://www.dge.de/wissenschaft/stellungnahmen-und-positionspapiere/positionen/neubewertung-der-position-zu-veganer-ernaehrung/" },
    { "label": "EFSA Tolerable Upper Intake Levels (UL)",              "url": "https://www.efsa.europa.eu/en/topics/topic/dietary-reference-values" },
    { "label": "ASMBS Nutritional Guidelines (post-bariatrisch)",       "url": "https://asmbs.org/resources/nutritional-guidelines-for-the-surgical-weight-loss-patient" },
    { "label": "Verbraucherzentrale – NEM in SS/Stillzeit",             "url": "https://www.verbraucherzentrale.de/wissen/lebensmittel/nahrungsergaenzungsmittel/mehr-drin-als-noetig-nahrungsergaenzung-rund-um-schwangerschaft-und-stillzeit-11633" }
  ],
  "phases": {
    "kinderwunsch": {
      "label": "Kinderwunsch",
      "nutrients": {
        "folat":      { "amount": "400 µg Folsäure/Tag (≥4 Wo. präkonzeptionell)", "level": "hoch",    "reason": "Neuralrohrdefekt-Prophylaxe; bei späterem Beginn 800 µg/Tag (BfR)",        "food_sources": ["Blattgemüse", "Hülsenfrüchte", "Vollkorn"],                  "upper_limit": "UL EFSA 1000 µg synth. Folsäure/Tag" },
        "eisen":      { "amount": "16 mg/Tag (DGE)",                                 "level": "moderat", "reason": "Speicheraufbau vor Konzeption senkt Anämierisiko in T2/T3",                  "food_sources": ["Hülsenfrüchte", "Vollkorn", "rotes Fleisch", "Haferflocken"], "upper_limit": "BfR NEM 6 mg/Tag; Substitution nur nach Labor" },
        "jod":        { "amount": "200 µg/Tag (DGE)",                                "level": "hoch",    "reason": "SD-Speicheraufbau für frühe Embryogenese; DE = mildes Jodmangelgebiet",       "food_sources": ["jodiertes Salz", "Seefisch", "Milchprodukte"],               "upper_limit": "BfR NEM 100 µg/Tag (Schwangere 150 µg)" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag (DGE)",                       "level": "moderat", "reason": "25-OH-D > 50 nmol/l vor Konzeption — Bezug zu Fertilität und Implantation",  "food_sources": ["fetter Seefisch", "Eigelb", "Sonnenlicht"],                   "upper_limit": "BfR NEM 20 µg/Tag; UL EFSA 100 µg/Tag" },
        "b12":        { "amount": "4,0 µg/Tag (DGE 2019)",                          "level": "moderat", "reason": "Speicher auffüllen — kritisch bei veg./veganer Kost",                       "food_sources": ["Fleisch", "Fisch", "Eier", "Milchprodukte"],                  "upper_limit": "Kein UL definiert" },
        "b_komplex":  { "amount": "B6 1,4 mg/Tag (DGE)",                            "level": "moderat", "reason": "B6 + Folat + B12 = Homocystein-Stoffwechsel, Zellteilung",                   "food_sources": ["Vollkorn", "Bananen", "Nüsse", "Geflügel"],                   "upper_limit": "B6 UL EFSA 12 mg/Tag; BfR NEM 3,5 mg/Tag" },
        "magnesium":  { "amount": "300–350 mg/Tag (DGE)",                           "level": "niedrig", "reason": "Basisbedarf; keine spezifische Kinderwunsch-Erhöhung evident",               "food_sources": ["Vollkorn", "Nüsse", "Hülsenfrüchte", "grünes Gemüse"],         "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag (DGE)",                          "level": "moderat", "reason": "Speicheraufbau für frühe ZNS-/Retina-Entwicklung",                           "food_sources": ["fetter Seefisch (Lachs, Makrele, Hering)", "Algenöl (vegan)"], "upper_limit": "EFSA: bis 5 g EPA+DHA/Tag" }
      }
    },
    "schwanger_t1": {
      "label": "Schwangerschaft · 1. Trimester",
      "nutrients": {
        "folat":      { "amount": "550 µg Folatäquiv./Tag — Supplement 400 µg bis SSW 12 (BfR)", "level": "hoch",    "reason": "Neuralrohrschluss bis Tag 28 p.c. — obligate Supplementierung",          "food_sources": ["Blattgemüse", "Hülsenfrüchte", "angereicherte Lebensmittel"], "upper_limit": "UL EFSA 1000 µg/Tag" },
        "eisen":      { "amount": "27 mg/Tag (DGE)",                                                "level": "hoch",    "reason": "Plasmavolumen-Expansion + fetaler Bedarf — ca. +100 % vs. nicht-SS",       "food_sources": ["rotes Fleisch", "Hülsenfrüchte", "Hafer + Vit-C-Kost"],         "upper_limit": "Substitution nur nach Labor" },
        "jod":        { "amount": "230 µg/Tag (DGE) — 100–150 µg davon als Supplement (BfR)",        "level": "hoch",    "reason": "Maternale T4 + fetale SD-Entwicklung",                                     "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],                          "upper_limit": "BfR NEM 150 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag (DGE)",                                       "level": "moderat", "reason": "Plazentafunktion + Präeklampsie-Modulation",                              "food_sources": ["Seefisch", "Eigelb", "Sonnenlicht"],                            "upper_limit": "BfR NEM 20 µg/Tag" },
        "b12":        { "amount": "4,5 µg/Tag (DGE)",                                               "level": "moderat", "reason": "Zellteilung, Erythropoese, Plazentatransfer",                              "food_sources": ["tierische Lebensmittel"],                                       "upper_limit": "Kein UL" },
        "b_komplex":  { "amount": "B6 1,5 mg/Tag",                                                  "level": "moderat", "reason": "B6 reduziert SS-Übelkeit (Cochrane); Homocysteinsenkung",                 "food_sources": ["Vollkorn", "Banane", "Kartoffel", "Geflügel"],                  "upper_limit": "UL EFSA 12 mg/Tag" },
        "magnesium":  { "amount": "310 mg < 25 J, 350 mg ≥ 25 J / Tag (DGE)",                       "level": "moderat", "reason": "Wadenkrämpfe, Uterus-Tonus — kein pauschales NEM laut DGE",               "food_sources": ["Vollkorn", "Nüsse", "Hülsenfrüchte"],                            "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                                                "level": "moderat", "reason": "Beginn fetale Neurogenese — Reduktion Frühgeburtsrisiko (Cochrane 2018)",  "food_sources": ["Seefisch 1–2×/Wo.", "Algenöl"],                                  "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "schwanger_t2": {
      "label": "Schwangerschaft · 2. Trimester",
      "nutrients": {
        "folat":      { "amount": "550 µg Folatäquiv./Tag",                                          "level": "moderat", "reason": "Nach Neuralrohrschluss reicht ernährungsbasierte Zufuhr; NEM nur bei Risiken", "food_sources": ["Blattgemüse", "Hülsenfrüchte"],                                  "upper_limit": "UL 1000 µg/Tag" },
        "eisen":      { "amount": "27 mg/Tag — Mehrbedarf fetal ca. +5 mg/Tag (AGG/OEGGG)",          "level": "hoch",    "reason": "Wachsendes Blutvolumen — erste Anämie-Manifestation ab ~SSW 20",            "food_sources": ["rotes Fleisch", "Hülsenfrüchte", "Vit-C-Kombi"],                  "upper_limit": "Substitution nach Ferritin/Hb (S1-LL 025/021)" },
        "jod":        { "amount": "230 µg/Tag",                                                      "level": "hoch",    "reason": "Anhaltend erhöhter Bedarf für fetale SD",                                  "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],                            "upper_limit": "BfR NEM 150 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag",                                              "level": "moderat", "reason": "Fortgesetzte Knochenmineralisation des Feten",                             "food_sources": ["Seefisch", "Sonnenlicht"],                                        "upper_limit": "UL 100 µg/Tag" },
        "b12":        { "amount": "4,5 µg/Tag",                                                      "level": "moderat", "reason": "Erythropoese; fetale Myelinisierung beginnt",                              "food_sources": ["tierische LM"],                                                   "upper_limit": "kein UL" },
        "b_komplex":  { "amount": "B6 1,8 mg/Tag (DGE T2/T3)",                                       "level": "moderat", "reason": "Eiweißstoffwechsel-Bedarf steigt",                                          "food_sources": ["Vollkorn", "Fleisch", "Nüsse"],                                   "upper_limit": "UL 12 mg/Tag" },
        "magnesium":  { "amount": "310–350 mg/Tag",                                                  "level": "moderat", "reason": "Häufig zur Tokolyse-Adjuvanz und gegen Wadenkrämpfe",                      "food_sources": ["Vollkorn", "Nüsse"],                                              "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                                                 "level": "moderat", "reason": "Hauptphase fetale ZNS-Entwicklung",                                        "food_sources": ["Seefisch", "Algenöl"],                                            "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "schwanger_t3": {
      "label": "Schwangerschaft · 3. Trimester",
      "nutrients": {
        "folat":      { "amount": "550 µg Folatäquiv./Tag",                                          "level": "moderat", "reason": "Erhaltungsbedarf",                                                          "food_sources": ["Blattgemüse", "Hülsenfrüchte"],                                  "upper_limit": "UL 1000 µg/Tag" },
        "eisen":      { "amount": "27 mg/Tag (DGE); klinisch oral 20–30 mg/Tag in letzten 2 Mon.",   "level": "hoch",    "reason": "Höchster fetaler Eisen-Transfer + Vorbereitung Geburtsblutverlust",         "food_sources": ["rotes Fleisch", "Linsen", "Haferflocken"],                        "upper_limit": "Therapeutisch nach Labor 30–80 mg/Tag (S1-LL)" },
        "jod":        { "amount": "230 µg/Tag",                                                      "level": "hoch",    "reason": "Bedarf bleibt erhöht",                                                      "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],                            "upper_limit": "BfR NEM 150 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag",                                              "level": "moderat", "reason": "Spitze fetaler Calcium-/Knochenaufbau im T3",                                "food_sources": ["Seefisch", "Sonnenlicht"],                                        "upper_limit": "UL 100 µg/Tag" },
        "b12":        { "amount": "4,5 µg/Tag",                                                      "level": "moderat", "reason": "Speicheranlage für Säugling über Stillzeit",                                "food_sources": ["tierische LM"],                                                   "upper_limit": "kein UL" },
        "b_komplex":  { "amount": "B6 1,8 mg/Tag",                                                   "level": "moderat", "reason": "Erhöhter Eiweißstoffwechsel kurz vor Geburt",                               "food_sources": ["Vollkorn", "Fleisch", "Nüsse"],                                   "upper_limit": "UL 12 mg/Tag" },
        "magnesium":  { "amount": "310–350 mg/Tag",                                                  "level": "moderat", "reason": "Wehenmodulation, Krampfprophylaxe",                                          "food_sources": ["Vollkorn", "Nüsse"],                                              "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                                                 "level": "moderat", "reason": "Maximaler DHA-Transfer 2. Lebenshälfte des Feten; Frühgeburtsrisiko sinkt",  "food_sources": ["Seefisch", "Algenöl"],                                            "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "wochenbett": {
      "label": "Wochenbett",
      "note": "DGE hat keinen separaten Wochenbett-Wert. Bei Stillenden Werte = Stillzeit; bei Nicht-Stillenden Erwachsenenwert + Regenerationsbedarf nach Geburtsblutverlust.",
      "nutrients": {
        "folat":      { "amount": "450 µg Folatäquiv./Tag",                                          "level": "moderat", "reason": "Erythropoese-Regeneration nach Geburt",                                      "food_sources": ["Blattgemüse", "Hülsenfrüchte"],                                  "upper_limit": "UL 1000 µg/Tag" },
        "eisen":      { "amount": "16 mg/Tag",                                                       "level": "hoch",    "reason": "Blutverlust sub partu 300–500 ml (vaginal) bis 1000 ml (Sectio)",            "food_sources": ["rotes Fleisch", "Hülsenfrüchte"],                                "upper_limit": "Bei Hb < 100 g/l: oral 80–200 mg/Tag (S1-LL)" },
        "jod":        { "amount": "200 µg/Tag (DGE-Update 2024)",                                    "level": "hoch",    "reason": "Säugling deckt SD-Bedarf vollständig über Muttermilch",                     "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],                            "upper_limit": "BfR NEM 150 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag",                                              "level": "moderat", "reason": "Knochen-Recovery, Stimmungsmodulation, geringer Übertrag in Muttermilch",     "food_sources": ["Seefisch", "Sonnenlicht"],                                        "upper_limit": "UL 100 µg/Tag" },
        "b12":        { "amount": "5,5 µg/Tag (Stillzeit)",                                          "level": "moderat", "reason": "B12-Übertrag in Muttermilch",                                                "food_sources": ["tierische LM"],                                                   "upper_limit": "kein UL" },
        "b_komplex":  { "amount": "B6 1,6 mg/Tag",                                                   "level": "moderat", "reason": "Erholung Eiweißstoffwechsel + Stillbedarf",                                "food_sources": ["Vollkorn", "Fleisch", "Nüsse"],                                   "upper_limit": "UL 12 mg/Tag" },
        "magnesium":  { "amount": "390 mg/Tag (DGE Stillzeit)",                                      "level": "moderat", "reason": "Mg-Verlust über Muttermilch + Krampfneigung erste Wochen",                  "food_sources": ["Vollkorn", "Nüsse"],                                              "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                                                 "level": "moderat", "reason": "Auffüllen mütterlicher Speicher + Übergang in Muttermilch",                  "food_sources": ["Seefisch", "Algenöl"],                                            "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "stillzeit_1_6m": {
      "label": "Stillzeit · Monat 1–6",
      "nutrients": {
        "folat":      { "amount": "450 µg Folatäquiv./Tag",                                          "level": "moderat", "reason": "Übertritt in Muttermilch",                                                  "food_sources": ["Blattgemüse", "Hülsenfrüchte"],                                  "upper_limit": "UL 1000 µg/Tag" },
        "eisen":      { "amount": "16 mg/Tag",                                                       "level": "moderat", "reason": "Kompensation SS-/Geburtsverlust; Muttermilch ist eisenarm",                  "food_sources": ["rotes Fleisch", "Hülsenfrüchte"],                                "upper_limit": "Substitution nur bei Diagnose" },
        "jod":        { "amount": "200 µg/Tag",                                                      "level": "hoch",    "reason": "Säugling deckt SD-Bedarf über Muttermilch",                                  "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],                            "upper_limit": "BfR NEM 150 µg/Tag — Vorsicht Hypothyreose-Risiko bei Überdosis" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag",                                              "level": "moderat", "reason": "Muttermilch transportiert wenig Vit D; Säugling erhält eigene Prophylaxe",     "food_sources": ["Seefisch", "Sonnenlicht"],                                        "upper_limit": "BfR NEM 20 µg/Tag" },
        "b12":        { "amount": "5,5 µg/Tag",                                                      "level": "hoch",    "reason": "Direkter Übertritt — B12-Mangel der Mutter führt rasch zu Säuglingsschäden",  "food_sources": ["tierische LM"],                                                   "upper_limit": "kein UL" },
        "b_komplex":  { "amount": "B6 1,6 mg/Tag",                                                   "level": "moderat", "reason": "Übertritt in Muttermilch; sehr hohe B6-Dosen können Milchbildung hemmen",     "food_sources": ["Vollkorn", "Fleisch", "Nüsse"],                                   "upper_limit": "UL 12 mg/Tag — > 200 mg dauerhaft: Neuropathierisiko" },
        "magnesium":  { "amount": "390 mg/Tag",                                                      "level": "moderat", "reason": "Höchster Mg-Bedarf aller Lebensphasen — Milchbildung",                       "food_sources": ["Vollkorn", "Nüsse"],                                              "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                                                 "level": "moderat", "reason": "ZNS-Entwicklung Säugling in ersten 6 Mo. sensibel für DHA",                  "food_sources": ["Seefisch", "Algenöl"],                                            "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "stillzeit_6_12m": {
      "label": "Stillzeit · Monat 6–12",
      "note": "DGE differenziert 1–6 vs. 6–12 nicht; Werte identisch. In der Praxis Bedarf parallel zur abnehmenden Stillmenge ↘ ab Beikost-Start.",
      "nutrients": {
        "folat":      { "amount": "450 µg Folatäquiv./Tag",         "level": "moderat", "reason": "Anhaltend leicht erhöht",                                "food_sources": ["Blattgemüse", "Hülsenfrüchte"],                "upper_limit": "UL 1000 µg/Tag" },
        "eisen":      { "amount": "16 mg/Tag",                       "level": "moderat", "reason": "Speicher-Erhaltung; Menses kehrt meist zurück",          "food_sources": ["rotes Fleisch", "Hülsenfrüchte"],              "upper_limit": "nur bei Diagnose" },
        "jod":        { "amount": "200 µg/Tag",                      "level": "hoch",    "reason": "Bei relevanter Stillmenge gleich hoch",                  "food_sources": ["jodiertes Salz", "Seefisch", "Milch"],         "upper_limit": "BfR NEM 150 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag",              "level": "moderat", "reason": "Identische Empfehlung",                                   "food_sources": ["Seefisch", "Sonnenlicht"],                      "upper_limit": "UL 100 µg/Tag" },
        "b12":        { "amount": "5,5 µg/Tag",                      "level": "hoch",    "reason": "Solange gestillt wird, gleicher Bedarf",                 "food_sources": ["tierische LM"],                                 "upper_limit": "kein UL" },
        "b_komplex":  { "amount": "B6 1,6 mg/Tag",                   "level": "moderat", "reason": "Identisch",                                              "food_sources": ["Vollkorn", "Fleisch", "Nüsse"],                "upper_limit": "UL 12 mg/Tag" },
        "magnesium":  { "amount": "390 mg/Tag",                      "level": "moderat", "reason": "Bei Teilstillen Bedarf ↘",                              "food_sources": ["Vollkorn", "Nüsse"],                            "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥200 mg DHA/Tag",                 "level": "moderat", "reason": "DHA in Muttermilch korreliert mit mütterlicher Zufuhr",   "food_sources": ["Seefisch", "Algenöl"],                          "upper_limit": "EFSA 5 g/Tag" }
      }
    },
    "mann_erwachsen": {
      "label": "Mann · 20–60 Jahre",
      "nutrients": {
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag (DGE)",         "level": "hoch",    "reason": "Endogene Synthese in DE Okt–März praktisch null; bevölkerungsweit häufig Status < 50 nmol/l — bei Männern oft unterschätzt",   "food_sources": ["fetter Seefisch", "Eigelb", "Sonnenlicht"],                "upper_limit": "UL EFSA 100 µg/Tag" },
        "magnesium":  { "amount": "350 mg/Tag (DGE)",                 "level": "moderat", "reason": "Erhöhter Bedarf bei Sport, Stress, hoher Phytatzufuhr",                                              "food_sources": ["Vollkorn", "Nüsse", "Hülsenfrüchte"],                       "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥250 mg EPA+DHA/Tag (DGE/EFSA)",   "level": "moderat", "reason": "Kardiovaskuläre Prävention; mediterrane Bevölkerungen erreichen es, deutsche Durchschnittskost meist nicht", "food_sources": ["Seefisch 1–2×/Woche", "Algenöl"],                          "upper_limit": "EFSA 5 g/Tag" },
        "zink":       { "amount": "11–14 mg/Tag (DGE, je nach Phytatzufuhr)", "level": "moderat", "reason": "Männer haben höheren Bedarf als Frauen (Testosteron-Synthese, Spermienreifung, Immunfunktion)",   "food_sources": ["Fleisch", "Vollkorn", "Hülsenfrüchte", "Kürbiskerne"],     "upper_limit": "BfR NEM 6,5 mg/Tag" },
        "b12":        { "amount": "4,0 µg/Tag (DGE 2019)",            "level": "moderat", "reason": "Bei Mischkost meist gedeckt — kritisch bei reduzierter tierischer Aufnahme",                          "food_sources": ["Fleisch", "Fisch", "Eier", "Milchprodukte"],               "upper_limit": "kein UL" },
        "folat":      { "amount": "300 µg Folatäquiv./Tag (DGE)",     "level": "moderat", "reason": "Grundbedarf erwachsener Mann; bei einseitiger Ernährung oft grenzwertig",                              "food_sources": ["Blattgemüse", "Hülsenfrüchte", "Vollkorn"],                "upper_limit": "UL EFSA 1000 µg synth./Tag" }
      }
    },
    "mann_senior": {
      "label": "Mann · > 60 Jahre",
      "nutrients": {
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag MIND. (DGE)",   "level": "hoch",    "reason": "Endogene Synthese ↓ mit Alter; Osteoporose- + Sarkopenie-Prävention",                                  "food_sources": ["fetter Seefisch", "Eigelb"],                                "upper_limit": "UL EFSA 100 µg/Tag" },
        "b12":        { "amount": "250–1000 µg/Tag oral",             "level": "hoch",    "reason": "Atrophische Gastritis bei 20–30 % der > 60-Jährigen → Resorption ↓ — Hochdosis nötig",                "food_sources": ["Fleisch", "Fisch", "Eier", "Milchprodukte"],               "upper_limit": "kein UL" },
        "calcium":    { "amount": "1000 mg/Tag (DGE)",                 "level": "moderat", "reason": "Osteoporose-Prävention bei Männern unterschätzt — Sturz-/Frakturrisiko",                              "food_sources": ["Milchprodukte", "Mineralwasser", "Grünkohl", "Sesam"],     "upper_limit": "BfR NEM 500 mg/Tag" },
        "magnesium":  { "amount": "350 mg/Tag",                       "level": "moderat", "reason": "Muskelfunktion, Schlafqualität, Sturz-Prophylaxe",                                                    "food_sources": ["Vollkorn", "Nüsse"],                                       "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥250 mg EPA+DHA/Tag",              "level": "moderat", "reason": "Kognitive Funktion + kardiovaskuläre + antiinflammatorische Wirkung",                                "food_sources": ["Seefisch", "Algenöl"],                                     "upper_limit": "EFSA 5 g/Tag" },
        "zink":       { "amount": "11 mg/Tag",                        "level": "moderat", "reason": "Immunfunktion + Wundheilung — bei Senioren häufig grenzwertig",                                       "food_sources": ["Fleisch", "Hülsenfrüchte"],                                "upper_limit": "BfR NEM 6,5 mg/Tag" }
      }
    },
    "ausserhalb": {
      "label": "Frau · außerhalb SS/Stillzeit",
      "nutrients": {
        "folat":      { "amount": "300 µg Folatäquiv./Tag (DGE)",     "level": "moderat", "reason": "Grundbedarf erwachsene Frau",                                  "food_sources": ["Blattgemüse", "Hülsenfrüchte", "Vollkorn"],     "upper_limit": "UL EFSA 1000 µg synth. Folsäure/Tag" },
        "eisen":      { "amount": "16 mg/Tag prämenopausal · 10 mg/Tag postmenopausal", "level": "moderat", "reason": "Menstruationsverlust prämenopausal; postmenopausal sinkender Bedarf", "food_sources": ["Hülsenfrüchte", "Vollkorn", "rotes Fleisch", "Haferflocken"], "upper_limit": "BfR NEM 6 mg/Tag" },
        "jod":        { "amount": "200 µg/Tag (DGE)",                 "level": "moderat", "reason": "DE = mildes Jodmangelgebiet — Salzversorgung sichern",          "food_sources": ["jodiertes Salz", "Seefisch", "Milchprodukte"],  "upper_limit": "BfR NEM 100 µg/Tag" },
        "vitamin_d":  { "amount": "20 µg = 800 IE/Tag (DGE)",         "level": "hoch",    "reason": "Endogene Synthese in DE Okt–März praktisch null; Bevölkerungsweit häufig Status < 50 nmol/l", "food_sources": ["fetter Seefisch", "Eigelb", "Sonnenlicht"], "upper_limit": "UL EFSA 100 µg/Tag" },
        "b12":        { "amount": "4,0 µg/Tag (DGE 2019)",            "level": "moderat", "reason": "Bei Mischkost meist gedeckt — bei reduzierter Tierprotein-Aufnahme kritisch", "food_sources": ["Fleisch", "Fisch", "Eier", "Milchprodukte"], "upper_limit": "kein UL definiert" },
        "magnesium":  { "amount": "300 mg/Tag (DGE)",                 "level": "moderat", "reason": "Stress, Sport, hoher Phytatgehalt der Kost (Vollkorn) erhöhen Bedarf", "food_sources": ["Vollkorn", "Nüsse", "Hülsenfrüchte"], "upper_limit": "BfR NEM 250 mg/Tag" },
        "omega3_dha": { "amount": "≥250 mg EPA+DHA/Tag (DGE/EFSA)",   "level": "moderat", "reason": "Mediterrane Bevölkerungen erreichen es; deutsche Durchschnittskost meist nicht", "food_sources": ["Seefisch 1–2×/Woche", "Algenöl"], "upper_limit": "EFSA 5 g/Tag" }
      }
    }
  },
  "modifiers": {
    "mehrlinge": {
      "label": "Mehrlinge",
      "note": "Keine DACH-Mehrlings-Referenzwerte. Faustregel (Springer 2025 / AGG): +25–50 % Mikronährstoffbedarf je weiterem Feten; engmaschige Labor-Kontrollen.",
      "adjust": {
        "folat":      "+200–400 µg Folsäure/Tag (gesamt 600–800 µg bis Ende T1)",
        "eisen":      "30–60 mg/Tag oral ab T2 nach Labor (OEGGG)",
        "jod":        "+50 µg/Tag (gesamt 250–300 µg)",
        "vitamin_d":  "individuell nach Spiegel, oft 1000–2000 IE/Tag",
        "magnesium":  "+50 mg/Tag",
        "omega3_dha": "300–400 mg DHA/Tag (Frühgeburtsrisiko ↑)"
      }
    },
    "vegan": {
      "label": "Vegan",
      "note": "Vegane Kost in SS/Stillzeit ist möglich, braucht aber gezielte Substitution und engmaschiges Labor-Monitoring (Ferritin, B12, 25-OH-D). Begleite mit klarem Substitutionsplan und kontrolliere die Werte regelmäßig.",
      "adjust": {
        "b12":        "obligat substituieren — 25–100 µg/Tag oral (Hochdosis wegen niedriger Absorption)",
        "jod":        "150 µg/Tag NEM zusätzlich zu jodiertem Salz",
        "eisen":      "Labor-basiert, häufig 30 mg/Tag + Vit-C-Kombi",
        "omega3_dha": "200–300 mg DHA/Tag aus Algenöl (ALA→DHA-Konversion < 5 %)",
        "vitamin_d":  "20 µg/Tag — vegane D3-Quelle (Flechten) oder D2",
        "b_komplex":  "B2 (Riboflavin) prüfen — bei Veganerinnen häufig grenzwertig"
      }
    },
    "vegetarisch": {
      "label": "Vegetarisch",
      "note": "Lakto-ovo-vegetarisch: meist nur Eisen und ggf. Omega-3 kritisch.",
      "adjust": {
        "eisen":      "Ferritin-Kontrolle, niedrigschwellig 30 mg/Tag",
        "omega3_dha": "200 mg DHA/Tag (Algenöl) bei Fischverzicht",
        "b12":        "Labor-Kontrolle, ggf. 10–25 µg/Tag",
        "jod":        "100–150 µg/Tag NEM falls kein Seefisch"
      }
    },
    "eisenmangel_dx": {
      "label": "Eisenmangel diagnostiziert",
      "note": "Therapie nach AWMF S1-LL 025/021 + OEGGG. Gabe alle 2 Tage zeigt bessere Resorption (Stoffel 2017) als tägliche Hochdosis.",
      "adjust": {
        "eisen":      "Leicht (Ferritin < 30 µg/l, Hb > 100): 30–80 mg/Tag oral alle 2 Tage · Mittel/schwer (Hb < 95 g/l) oder T3/Unverträglichkeit: i.v. Eisencarboxymaltose 1000–1500 mg · Ziel Hb > 110 g/l, Ferritin > 30 µg/l",
        "vitamin_c":  "200 mg Vit C zu jeder Eisen-Einnahme (Resorption × 2–3)"
      }
    },
    "gdm": {
      "label": "Gestationsdiabetes",
      "note": "S3-LL GDM 057-008: Ernährungstherapie an erster Stelle. Mikronährstoff-Defizite (Vit D, Mg, B12 bei Metformin) gezielt kontrollieren.",
      "adjust": {
        "vitamin_d":  "Spiegel-orientiert, oft 1000–2000 IE/Tag (HbA1c, Insulinresistenz ↓)",
        "magnesium":  "300 mg/Tag NEM bei Mg-Mangel — niedriger Mg-Status = späteres T2DM-Risiko",
        "b12":        "Bei Metformin: 1000 µg/Tag oral oder Labor alle 6 Mo. (Metformin senkt B12-Resorption)",
        "folat":      "Bei Metformin Folat-Spiegel überwachen",
        "omega3_dha": "200–300 mg DHA/Tag (antiinflammatorisch)"
      }
    },
    "sectio": {
      "label": "Z. n. Sectio",
      "note": "Mittlere Bauch-OP. Mehrbedarf für Proteine, Zink, Vit C, B-Vitamine in den ersten 4–6 Wochen. Blutverlust meist 700–1000 ml.",
      "adjust": {
        "eisen":      "Hb-Kontrolle Tag 2–3 · Hb < 95 g/l → i.v. Eisencarboxymaltose 500–1000 mg · Hb 95–105 g/l → oral 80–160 mg/Tag",
        "b_komplex":  "B1/B6/B12 für 4–6 Wo. ergänzen — Wundheilung, Energie",
        "magnesium":  "300–400 mg/Tag — Krampfprophylaxe + Muskelregeneration Bauchdecke",
        "vitamin_c":  "200 mg/Tag bis Narbenheilung abgeschlossen — Kollagensynthese-Cofaktor",
        "zink":       "10 mg/Tag — Wundheilung + Immunfunktion"
      }
    },
    "bariatrie": {
      "label": "Z. n. bariatrische OP",
      "note": "Risikoschwangerschaft (SGA, IUGR ↑). Karenz ≥ 12–24 Mo. nach OP. Lebenslange Substitution, in SS/Stillzeit intensiviert. Quartalsweise Labor: Ferritin, B12, Folat, 25-OH-D, Ca, Zn, Cu, A/E/K.",
      "adjust": {
        "b12":        "1000 µg/Tag oral oder 1000 µg i.m. alle 1–3 Mo. — fehlender Intrinsic Factor",
        "eisen":      "45–60 mg/Tag (SS: 50–100 mg/Tag) — Sulfat/Fumarat/Gluconat",
        "folat":      "800–1000 µg/Tag — reduzierte Resorption proximaler Dünndarm",
        "vitamin_d":  "2000–4000 IE/Tag, Spiegel-gesteuert",
        "calcium":    "1200–1500 mg/Tag (Citrat bevorzugt)",
        "vitamin_a":  "VORSICHT — max. 2500–5000 IE/Tag als Retinol (höhere Dosen teratogen)",
        "thiamin_b1": "12–50 mg/Tag — Wernicke-Prophylaxe bei Hyperemesis",
        "omega3_dha": "200–300 mg DHA/Tag"
      }
    },
    "adipositas": {
      "label": "Adipositas (BMI ≥ 30)",
      "note": "„Hidden hunger\" trotz hoher Energieaufnahme dokumentiert (Astrup, Bays et al.). Reduktionskost ohne Mikronährstoff-Sicherheit verstärkt Defizite weiter. Spiegel-Kontrolle vor Reduktionsbeginn ist Standard nach S3-LL 050-001.",
      "adjust": {
        "vitamin_d":  "Defizit-Rate 60–90 % — initial 2000–4000 IE/Tag, Spiegel-gesteuert; bei Adipositas III ggf. höher (sequestration in Fettgewebe)",
        "magnesium":  "300–400 mg/Tag NEM — bei Adipositas mit metabolischem Syndrom oft grenzwertig",
        "b12":        "Spiegel prüfen, ggf. 250–500 µg/Tag — insb. bei vegetarischer/pflanzlicher Reduktionskost oder Metformin",
        "folat":      "Spiegel-Kontrolle — Defizit häufig bei einseitiger Ernährung trotz hoher kcal",
        "eisen":      "Ferritin-Kontrolle — chronische niedrig-gradige Inflammation kann Eisen-Status maskieren",
        "omega3_dha": "≥250 mg/Tag (antiinflammatorisch, Insulinsensitivität)"
      }
    },
    "lowcarb": {
      "label": "LowCarb / Ketogene Reduktionsstrategie",
      "note": "Strikt < 50 g KH/Tag senkt Aufnahme von Folat, Ballaststoffen, Magnesium und Kalium aus Vollkorn/Hülsenfrüchten. Erste Wochen häufig „Keto-Grippe\" durch Elektrolyt-Verluste.",
      "adjust": {
        "magnesium":  "400 mg/Tag — Renale Mg-Verluste in Ketose ↑",
        "folat":      "Spiegel prüfen, ggf. 400 µg/Tag",
        "vitamin_d":  "20 µg/Tag (Standard)",
        "b_komplex":  "Niedrigschwellig substituieren — Thiamin, B6 aus Vollkorn entfallen"
      }
    },
    "vlcd": {
      "label": "Very-Low-Calorie-Diät (VLCD, < 800 kcal/Tag)",
      "note": "Nach S3-LL 050-001 nur ärztlich begleitet, max. 12 Wochen. Mikronährstoff-Substitution OBLIGAT — Formula-Produkte decken meist Grundbedarf, aber bei Eigenrezepturen kritisch.",
      "adjust": {
        "vitamin_d":  "20 µg/Tag (Multivitamin-Basis)",
        "b_komplex":  "Vollständig substituieren — B1 Wernicke-Prophylaxe",
        "eisen":      "Spiegel-orientiert — orales Eisen oft nicht resorbiert bei niedriger Magensäure",
        "magnesium":  "300 mg/Tag",
        "omega3_dha": "≥250 mg/Tag",
        "calcium":    "1000 mg/Tag — Knochenstoffwechsel"
      }
    },
    "pflanzliche_reduktion": {
      "label": "Pflanzliche Reduktionskost (vegetarisch/vegan + kcal-Defizit)",
      "note": "Kombination aus pflanzlicher Kost + Reduktion verstärkt B12-/Eisen-/D3-Risiko. DGE-Position vegane Ernährung 2024: qualifizierte Beratung dringend angeraten.",
      "adjust": {
        "b12":        "obligat 25–100 µg/Tag",
        "eisen":      "30 mg/Tag oral + Vitamin-C-Kombi zur Mahlzeit",
        "vitamin_d":  "20 µg/Tag (pflanzliche D3-Quelle aus Flechten)",
        "omega3_dha": "200–300 mg DHA/Tag (Algenöl)",
        "calcium":    "1000 mg/Tag bei Verzicht auf Milchprodukte",
        "zink":       "10 mg/Tag — Bioverfügbarkeit aus pflanzlichen Quellen reduziert (Phytat)",
        "jod":        "100–150 µg/Tag bei Verzicht auf Seefisch + jodiertes Salz"
      }
    },
    "prae_bariatrisch": {
      "label": "Prä-bariatrische Phase",
      "note": "ASMBS/S3-LL 088-001: Defizit-Status vor OP korrigieren. Häufig D3, Eisen, B12, Folat bereits präoperativ erniedrigt — Korrektur senkt postop. Komplikationen.",
      "adjust": {
        "vitamin_d":  "Bis ≥ 75 nmol/l auffüllen, 2000–4000 IE/Tag",
        "eisen":      "Bei Ferritin < 30 µg/l: 30–80 mg/Tag oral, ggf. i.v.",
        "b12":        "Bei < 200 pmol/l: 1000 µg/Tag oral",
        "folat":      "Spiegel prüfen, ggf. 400–800 µg/Tag",
        "thiamin_b1": "50 mg/Tag — Wernicke-Prophylaxe"
      }
    },
    "post_bariatrisch": {
      "label": "Post-bariatrisch (lebenslange Substitution)",
      "note": "Lebenslange Substitution nach ASMBS-Standards. Quartalsweise Labor erste 2 Jahre, danach halbjährlich. Lasse mit operierender Klinik abstimmen.",
      "adjust": {
        "b12":        "1000 µg/Tag oral oder 1000 µg i.m. alle 1–3 Mo.",
        "eisen":      "45–60 mg/Tag (Frauen prämenopausal ggf. mehr)",
        "folat":      "400–800 µg/Tag",
        "vitamin_d":  "2000–4000 IE/Tag, Spiegel-gesteuert",
        "calcium":    "1200–1500 mg/Tag (Citrat)",
        "zink":       "10–15 mg/Tag",
        "thiamin_b1": "50 mg/Tag — lebenslang",
        "vitamin_a":  "Substitution + Spiegel — max. 5000 IE/Tag bei Frauen im gebärfähigen Alter (teratogen)"
      }
    },
    "pcos": {
      "label": "PCOS (Polyzystisches Ovarialsyndrom)",
      "note": "S3-LL 015-085 international. Insulinresistenz ist Kern-Pathologie — Mikronährstoff-Status beeinflusst Glukose- + Androgen-Stoffwechsel.",
      "adjust": {
        "vitamin_d":  "Bei Defizit: 2000 IE/Tag — Spiegel ≥ 75 nmol/l (Insulinsensitivität, Zyklus)",
        "magnesium":  "300 mg/Tag — bei Insulinresistenz häufig erniedrigt",
        "omega3_dha": "≥1 g EPA+DHA/Tag — Androgen-Reduktion in Metaanalysen",
        "b_komplex":  "B6 (Inositol-Synergie) — 1,6 mg/Tag Basis, bei Inositol-Therapie ergänzen",
        "zink":       "10 mg/Tag — Androgen-Modulation"
      }
    },
    "dm2": {
      "label": "Diabetes mellitus Typ 2",
      "note": "Mikronährstoff-Sicherheit ergänzt die Ernährungs- und Verhaltenstherapie — ersetzt sie NICHT. Bei Metformin-Therapie B12-Verlust dokumentiert.",
      "adjust": {
        "b12":        "Bei Metformin: 250–500 µg/Tag oral, jährlich Spiegel",
        "vitamin_d":  "20–50 µg/Tag — Insulinsensitivität in Studien",
        "magnesium":  "300 mg/Tag — Insulinrezeptor-Cofaktor",
        "omega3_dha": "≥1 g/Tag — Triglyzeride, Inflammation",
        "folat":      "Bei Metformin Spiegel-Kontrolle"
      }
    },
    "senior": {
      "label": "Senior:in (> 65)",
      "note": "Reduzierte Magensäureproduktion → B12-Resorption ↓. Sarkopenie-Prophylaxe braucht Proteinsicherheit + D3 + Mg.",
      "adjust": {
        "b12":        "Hochdosis 250–1000 µg/Tag oral — atrophische Gastritis bei 20–30 % der > 60-Jährigen",
        "vitamin_d":  "20 µg = 800 IE/Tag MIND. — endogene Synthese ↓",
        "calcium":    "1000 mg/Tag — Osteoporose-Prophylaxe",
        "magnesium":  "300 mg/Tag — Muskelfunktion, Schlaf",
        "omega3_dha": "≥250 mg/Tag — kognitive Funktion + antiinflammatorisch"
      }
    }
  },
  "actinovo_map": {
    "eisen":      { "name": "Liposomales Eisen",       "url": "https://actinovo.com/products/liposomales-eisen-kirsche-new-generation", "price": "20,90 €" },
    "b_komplex":  { "name": "Liposomales B-Komplex",   "url": "https://actinovo.com/products/liposomales-b-komplex",                     "price": "24,90 €" },
    "b12":        { "name": "Liposomales B-Komplex",   "url": "https://actinovo.com/products/liposomales-b-komplex",                     "price": "24,90 €" },
    "thiamin_b1": { "name": "Liposomales B-Komplex",   "url": "https://actinovo.com/products/liposomales-b-komplex",                     "price": "24,90 €" },
    "vitamin_d":  { "name": "Liposomales D3/K2",       "url": "https://actinovo.com/products/liposomales-vitamin-d3-k2",                 "price": "23,90 €" },
    "magnesium":  { "name": "Liposomales Magnesium",   "url": "https://actinovo.com/products/liposomales-magnesium-basilikum-zitrone-holunder", "price": "25,90 €" },
    "omega3_dha": { "name": "Liposomales Omega-3 DHA", "url": "https://actinovo.com/products/omega-3-orange-liposomal-flavoured",         "price": "36,90 €" },
    "vitamin_c":  { "name": "Liposomales Vitamin C + Zink", "url": "https://actinovo.com/products/liposomales-vitamin-c-zink",            "price": null }
  },
  "nutrient_labels": {
    "folat":      "Folat / Folsäure",
    "eisen":      "Eisen",
    "jod":        "Jod",
    "vitamin_d":  "Vitamin D3/K2",
    "b12":        "Vitamin B12",
    "b_komplex":  "B-Komplex (B6)",
    "magnesium":  "Magnesium",
    "omega3_dha": "Omega-3 DHA",
    "vitamin_c":  "Vitamin C",
    "zink":       "Zink",
    "calcium":    "Calcium",
    "vitamin_a":  "Vitamin A",
    "thiamin_b1": "Thiamin (B1)"
  }
}; }

/* ============ STATE ============ */
const state = {
  gender: null,            // frau | mann | divers
  phase: null,
  form: 'misch',           // misch | vegetarisch | vegan | pescetarisch
  reduction: null,         // null | lowcarb | vlcd | pflanzliche_reduktion
  modifiers: new Set(),    // aktivierte Modifier (außer reduction + form)
  praxisName: '',
  praxisStadt: '',
  praxisLogo: null,        // dataURL
  klientin: '',
  alter: '',
  kommentar: '',
};

/* Welche Phasen pro Geschlecht angeboten werden */
const PHASES_BY_GENDER = {
  frau:   ['kinderwunsch', 'schwanger_t1', 'schwanger_t2', 'schwanger_t3', 'wochenbett', 'stillzeit_1_6m', 'stillzeit_6_12m', 'ausserhalb'],
  mann:   ['mann_erwachsen', 'mann_senior'],
  divers: ['mann_erwachsen', 'mann_senior', 'ausserhalb'],   // alle non-SS-Phasen
};

/* ============ HELPERS ============ */
function $(id) { return document.getElementById(id); }
function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function dateLong() {
  const d = new Date();
  return d.toLocaleDateString('de-DE', { day:'2-digit', month:'long', year:'numeric' });
}
function slugify(s) {
  return (s || '').toLowerCase().replace(/[äöüß]/g, c => ({ä:'ae',ö:'oe',ü:'ue',ß:'ss'}[c] || c))
    .replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'') || 'praxis';
}

/* ============ UI RENDERING ============ */
function renderPhaseChips() {
  const grid = $('phaseChips');
  grid.innerHTML = '';
  if (!state.gender) return;
  const order = PHASES_BY_GENDER[state.gender] || [];
  for (const key of order) {
    if (!DATA.phases[key]) continue;
    const c = document.createElement('span');
    c.className = 'chip';
    c.dataset.phase = key;
    c.textContent = DATA.phases[key].label;
    if (state.phase === key) c.classList.add('active');
    c.addEventListener('click', () => {
      state.phase = (state.phase === key) ? null : key;
      grid.querySelectorAll('.chip').forEach(x => x.classList.remove('active'));
      if (state.phase) c.classList.add('active');
      track('phase_selected', { phase: state.phase });
      renderPreview();
    });
    grid.appendChild(c);
  }
}

/* Geschlechts-spezifische Modifier-Chips ausblenden */
function applyGenderFilter() {
  document.querySelectorAll('[data-gender-only]').forEach(el => {
    const only = el.dataset.genderOnly;  // 'frau' | 'mann'
    if (!state.gender || state.gender === 'divers' || state.gender === only) {
      el.style.display = '';
    } else {
      el.style.display = 'none';
      // Falls aktiv: deaktivieren
      if (el.classList.contains('active')) {
        el.classList.remove('active');
        const mod = el.dataset.mod;
        if (mod) state.modifiers.delete(mod);
      }
    }
  });
}

function wireGenderChips() {
  const c = $('genderChips');
  c.querySelectorAll('.chip').forEach(chip => {
    chip.addEventListener('click', () => {
      const g = chip.dataset.gender;
      // Beim Geschlechts-Wechsel Phase zurücksetzen, da andere Phasen-Liste
      if (state.gender !== g) state.phase = null;
      state.gender = g;
      c.querySelectorAll('.chip').forEach(x => x.classList.remove('active'));
      chip.classList.add('active');
      $('phaseStep').style.display = '';
      renderPhaseChips();
      applyGenderFilter();
      track('gender_selected', { gender: g });
      renderPreview();
    });
  });
}

function wireChipGroup(containerId, stateField, options) {
  const c = $(containerId);
  if (!c) return;
  c.querySelectorAll('.chip').forEach(chip => {
    chip.addEventListener('click', () => {
      const v = chip.dataset.form || chip.dataset.mod;
      if (options.multi) {
        // Modifier-Set
        if (state.modifiers.has(v)) {
          state.modifiers.delete(v);
          chip.classList.remove('active');
        } else {
          state.modifiers.add(v);
          chip.classList.add('active');
        }
        track('modifier_toggled', { modifier: v, active: state.modifiers.has(v) });
      } else {
        // Single-select
        c.querySelectorAll('.chip').forEach(x => x.classList.remove('active'));
        chip.classList.add('active');
        if (stateField === 'reduction' && v === 'none') {
          state.reduction = null;
        } else {
          state[stateField] = v;
        }
        track(stateField + '_selected', { value: v });
      }
      renderPreview();
    });
  });
}

function wireInputs() {
  $('erbName').addEventListener('input', e => { state.praxisName = e.target.value; renderPreview(); });
  $('erbStadt').addEventListener('input', e => { state.praxisStadt = e.target.value; renderPreview(); });
  $('klientin').addEventListener('input', e => { state.klientin = e.target.value; renderPreview(); });
  $('alter').addEventListener('input', e => { state.alter = e.target.value; renderPreview(); });
  $('kommentar').addEventListener('input', e => { state.kommentar = e.target.value; renderPreview(); });
  $('erbLogo').addEventListener('change', e => {
    const file = e.target.files[0];
    if (!file) { state.praxisLogo = null; renderPreview(); return; }
    if (file.size > 1024 * 1024) {
      alert('Logo bitte unter 1 MB.');
      e.target.value = '';
      return;
    }
    const reader = new FileReader();
    reader.onload = ev => { state.praxisLogo = ev.target.result; renderPreview(); };
    reader.readAsDataURL(file);
  });
}

/* ============ PREVIEW LOGIC ============ */
function activeModifiers() {
  const list = [];
  // Ernährungsform (vegan/vegetarisch sind als Modifier in DATA.modifiers)
  if (state.form === 'vegan' && DATA.modifiers.vegan) list.push('vegan');
  if (state.form === 'vegetarisch' && DATA.modifiers.vegetarisch) list.push('vegetarisch');
  // Stoffwechsel-Modifier
  for (const m of state.modifiers) {
    if (DATA.modifiers[m]) list.push(m);
  }
  // Reduktion
  if (state.reduction && DATA.modifiers[state.reduction]) list.push(state.reduction);
  return list;
}

function renderPreview() {
  const empty = $('pvEmpty'), content = $('pvContent');
  const btnPdf = $('downloadPdfBtn'), btnHtml = $('downloadHtmlBtn');
  if (!state.phase) {
    empty.style.display = 'block'; content.style.display = 'none';
    btnPdf.disabled = true; btnHtml.disabled = true;
    return;
  }
  empty.style.display = 'none'; content.style.display = 'block';
  btnPdf.disabled = false; btnHtml.disabled = false;

  const phase = DATA.phases[state.phase];
  const labels = DATA.nutrient_labels;
  const mods = activeModifiers();

  // Header
  $('pvEyebrow').textContent = state.praxisName ? `Beratung · ${escapeHtml(state.praxisName)}` : 'Beratung';
  $('pvHeading').textContent = phase.label;
  const personal = [];
  if (state.klientin) personal.push('Für: ' + state.klientin);
  if (state.alter) personal.push(state.alter + ' Jahre');
  personal.push(dateLong());
  $('pvPersonal').textContent = personal.join(' · ');

  // Nutrients (Basis aus Phase, dann Modifier-Anpassungen mergen)
  const merged = {};
  for (const k of Object.keys(phase.nutrients)) {
    merged[k] = { ...phase.nutrients[k], _source: 'phase' };
  }
  for (const m of mods) {
    const mod = DATA.modifiers[m];
    if (!mod.adjust) continue;
    for (const [k, val] of Object.entries(mod.adjust)) {
      if (merged[k]) {
        merged[k] = { ...merged[k], amount: val, reason: merged[k].reason + ' · ' + mod.label + ': angepasst' };
      } else {
        merged[k] = { amount: val, level: 'moderat', reason: 'Hinzugefügt durch ' + mod.label, food_sources: [], upper_limit: '' };
      }
    }
  }

  // Render Nutrients
  const nutHtml = Object.entries(merged).map(([k, n]) => {
    const label = labels[k] || k;
    const lvlClass = n.level === 'hoch' ? 'lvl-hoch' : 'lvl-moderat';
    return `<div class="nutrient ${lvlClass}">
      <div class="nutrient-head">
        <span class="nutrient-name">${escapeHtml(label)}</span>
        <span class="nutrient-amount">${escapeHtml(n.amount)}</span>
      </div>
      <div class="nutrient-reason">${escapeHtml(n.reason)}</div>
      ${n.food_sources && n.food_sources.length ? `<div class="nutrient-food"><strong>Lebensmittelquellen:</strong> ${n.food_sources.map(escapeHtml).join(' · ')}</div>` : ''}
    </div>`;
  }).join('');
  $('pvNutrients').innerHTML = nutHtml;

  // Modifier-Notes
  const modSec = $('pvModifierSection');
  if (mods.length) {
    modSec.style.display = 'block';
    $('pvModifiers').innerHTML = mods.map(m => {
      const mod = DATA.modifiers[m];
      return `<div class="modifier-note"><strong>${escapeHtml(mod.label)}</strong>${escapeHtml(mod.note || '')}</div>`;
    }).join('');
  } else {
    modSec.style.display = 'none';
  }

  // ActiNovo Block (only if any relevant nutrient is in actinovo_map)
  const relevantProducts = Object.keys(merged).filter(k => DATA.actinovo_map && DATA.actinovo_map[k]);
  const acBlock = $('pvActinovo');
  if (relevantProducts.length) {
    acBlock.style.display = 'flex';
    const slug = slugify(state.praxisName);
    const qrTarget = `https://actinovo.com/discount/Ern%25C3%25A4hrung15?redirect=%2Fcollections%2Fall&utm_source=praxis&utm_medium=qr&utm_campaign=erb-tool&utm_content=${encodeURIComponent(slug)}`;
    const qrSlot = $('pvQr');
    qrSlot.title = qrTarget;
    try {
      const qrUrl = qrCanvasDataURL(qrTarget, 128);
      qrSlot.innerHTML = `<img src="${qrUrl}" alt="QR-Code" style="width:100%;height:100%;display:block">`;
    } catch (e) {
      qrSlot.textContent = 'QR';
    }
  } else {
    acBlock.style.display = 'none';
  }

  // Sources
  $('pvSources').innerHTML = 'Quellen: ' +
    DATA.sources.slice(0, 4).map(s => `<a href="${escapeHtml(s.url)}" target="_blank" rel="noopener">${escapeHtml(s.label)}</a>`).join(' · ');
}

/* ============ ACTIONS ============ */

/* Helper: berechne den gemergten Nährstoff-Datensatz (für PDF + HTML gleich) */
function buildMergedData() {
  const phase = DATA.phases[state.phase];
  const mods = activeModifiers();
  const merged = {};
  for (const k of Object.keys(phase.nutrients)) merged[k] = { ...phase.nutrients[k] };
  for (const m of mods) {
    const mod = DATA.modifiers[m]; if (!mod.adjust) continue;
    for (const [k, val] of Object.entries(mod.adjust)) {
      if (merged[k]) merged[k] = { ...merged[k], amount: val };
      else merged[k] = { amount: val, level: 'moderat', reason: 'Hinzugefügt durch ' + mod.label, food_sources: [] };
    }
  }
  return { phase, mods, merged };
}

function qrCanvasDataURL(text, sizePx) {
  // qrcode-generator lib (typeNumber=0 → auto, M-level)
  const qr = qrcode(0, 'M');
  qr.addData(text);
  qr.make();
  const count = qr.getModuleCount();
  const cell = Math.max(1, Math.floor(sizePx / count));
  const real = cell * count;
  const canvas = document.createElement('canvas');
  canvas.width = real; canvas.height = real;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, real, real);
  ctx.fillStyle = '#003087';
  for (let r = 0; r < count; r++) {
    for (let c = 0; c < count; c++) {
      if (qr.isDark(r, c)) ctx.fillRect(c * cell, r * cell, cell, cell);
    }
  }
  return canvas.toDataURL('image/png');
}

async function downloadPdf() {
  if (!state.phase) return;
  track('pdf_generated', { phase: state.phase, modifier_count: activeModifiers().length });

  const { jsPDF } = window.jspdf;
  const pdf = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'p' });

  // Brand
  const BRAND = [0, 48, 135];        // var(--brand)
  const BRAND_SOFT = [0, 146, 255];
  const GOLD = [127, 205, 242];
  const INK = [21, 33, 27];
  const INK_SOFT = [74, 86, 80];
  const INK_MUTE = [123, 135, 128];
  const TINT = [232, 237, 242];

  const PW = pdf.internal.pageSize.getWidth();   // 210
  const PH = pdf.internal.pageSize.getHeight();  // 297
  const M = 16;                                  // margin mm
  const W = PW - 2 * M;                          // content width
  let y = M;

  const { phase, mods, merged } = buildMergedData();
  const labels = DATA.nutrient_labels;
  const slug = slugify(state.praxisName);
  const qrTarget = `https://actinovo.com/discount/Ern%25C3%25A4hrung15?redirect=%2Fcollections%2Fall&utm_source=praxis&utm_medium=pdf&utm_campaign=erb-tool&utm_content=${encodeURIComponent(slug)}`;

  // Pagebreak helper
  function need(h) {
    if (y + h > PH - M) { pdf.addPage(); y = M; }
  }

  /* ── HEADER ── */
  // Logo links (falls vorhanden), Praxis-Info rechts
  if (state.praxisLogo) {
    try {
      pdf.addImage(state.praxisLogo, 'PNG', M, y, 32, 14, undefined, 'FAST');
    } catch (e) {}
  } else {
    pdf.setFont('helvetica', 'bold').setFontSize(11).setTextColor(...BRAND);
    pdf.text('Mikronährstoff-Briefing', M, y + 5);
  }
  if (state.praxisName || state.praxisStadt) {
    pdf.setFont('helvetica', 'normal').setFontSize(10).setTextColor(...INK);
    pdf.text(state.praxisName || '', PW - M, y + 4, { align: 'right' });
    if (state.praxisStadt) {
      pdf.setFontSize(8.5).setTextColor(...INK_MUTE);
      pdf.text(state.praxisStadt, PW - M, y + 9, { align: 'right' });
    }
  }
  y += 18;
  pdf.setDrawColor(...BRAND).setLineWidth(0.6);
  pdf.line(M, y, PW - M, y);
  y += 10;

  /* ── TITLE-Block ── */
  pdf.setFont('helvetica', 'bold').setFontSize(20).setTextColor(...BRAND);
  pdf.text('Mikronährstoff-Briefing', M, y);
  y += 7;
  pdf.setFont('helvetica', 'normal').setFontSize(13).setTextColor(...INK);
  pdf.text(phase.label, M, y);
  y += 8;
  // Klient-/Date-Zeile
  pdf.setFont('helvetica', 'normal').setFontSize(9.5).setTextColor(...INK_MUTE);
  const personal = [];
  if (state.klientin) personal.push('Für: ' + state.klientin);
  if (state.alter) personal.push(state.alter + ' Jahre');
  personal.push(dateLong());
  pdf.text(personal.join('  ·  '), M, y);
  y += 10;

  /* ── SECTION: Mikronährstoffe ── */
  pdf.setFont('helvetica', 'bold').setFontSize(9).setTextColor(...BRAND);
  pdf.text('EMPFOHLENE MIKRONÄHRSTOFFE  ·  Tagesbedarf', M, y);
  y += 2;
  pdf.setDrawColor(...BRAND).setLineWidth(0.3); pdf.line(M, y, PW - M, y);
  y += 6;

  for (const [k, n] of Object.entries(merged)) {
    const label = labels[k] || k;
    // Höhe der Reihe abschätzen für Page-Break
    pdf.setFontSize(9.5).setFont('helvetica', 'normal');
    const reasonLines = pdf.splitTextToSize(n.reason || '', W - 4);
    const foodText = (n.food_sources && n.food_sources.length) ? 'Lebensmittel: ' + n.food_sources.join(' · ') : '';
    const foodLines = foodText ? pdf.splitTextToSize(foodText, W - 4) : [];
    const rowH = 6 + reasonLines.length * 3.6 + foodLines.length * 3.6 + 3;
    need(rowH);

    // Level-Indikator (Strich links)
    pdf.setFillColor(...(n.level === 'hoch' ? BRAND : GOLD));
    pdf.rect(M, y - 4, 1.4, rowH - 2, 'F');

    // Name + Menge (gleiche Zeile)
    pdf.setFont('helvetica', 'bold').setFontSize(10.5).setTextColor(...INK);
    pdf.text(label, M + 4, y);
    pdf.setFont('helvetica', 'normal').setFontSize(10).setTextColor(...BRAND);
    pdf.text(n.amount || '', PW - M, y, { align: 'right' });
    y += 4.5;

    // Begründung
    pdf.setFont('helvetica', 'normal').setFontSize(9).setTextColor(...INK_SOFT);
    for (const line of reasonLines) { pdf.text(line, M + 4, y); y += 3.6; }
    // Lebensmittel
    if (foodLines.length) {
      pdf.setFontSize(8.5).setTextColor(...INK_MUTE);
      for (const line of foodLines) { pdf.text(line, M + 4, y); y += 3.6; }
    }
    y += 3;
  }

  /* ── SECTION: Modifier-Notes ── */
  if (mods.length) {
    y += 3;
    need(15);
    pdf.setFont('helvetica', 'bold').setFontSize(9).setTextColor(...BRAND);
    pdf.text('SITUATIONSBEDINGTE HINWEISE', M, y);
    y += 2;
    pdf.setDrawColor(...BRAND).setLineWidth(0.3); pdf.line(M, y, PW - M, y);
    y += 5;

    for (const m of mods) {
      const mo = DATA.modifiers[m];
      pdf.setFontSize(9).setFont('helvetica', 'normal');
      const noteLines = pdf.splitTextToSize(mo.note || '', W - 6);
      const boxH = 6 + noteLines.length * 3.8 + 3;
      need(boxH);
      pdf.setFillColor(...TINT); pdf.roundedRect(M, y - 4, W, boxH, 1.5, 1.5, 'F');
      pdf.setFont('helvetica', 'bold').setFontSize(9.5).setTextColor(...BRAND);
      pdf.text(mo.label, M + 3, y);
      y += 4.5;
      pdf.setFont('helvetica', 'normal').setFontSize(8.8).setTextColor(...INK_SOFT);
      for (const line of noteLines) { pdf.text(line, M + 3, y); y += 3.8; }
      y += 4;
    }
  }

  /* ── SECTION: Notiz der Berater:in ── */
  if (state.kommentar && state.kommentar.trim()) {
    y += 3;
    need(15);
    pdf.setFont('helvetica', 'bold').setFontSize(9).setTextColor(...BRAND);
    pdf.text('NOTIZ DER BERATER:IN', M, y);
    y += 2;
    pdf.setDrawColor(...BRAND).setLineWidth(0.3); pdf.line(M, y, PW - M, y);
    y += 5;
    pdf.setFont('helvetica', 'italic').setFontSize(9.5).setTextColor(...INK_SOFT);
    const lines = pdf.splitTextToSize(state.kommentar, W);
    for (const line of lines) { need(5); pdf.text(line, M, y); y += 4.2; }
  }

  /* ── ACTINOVO-Block ── */
  const relevantProducts = Object.keys(merged).filter(k => DATA.actinovo_map && DATA.actinovo_map[k]);
  if (relevantProducts.length) {
    y += 4;
    need(40);
    // Highlight-Frame
    pdf.setFillColor(240, 245, 250);
    pdf.setDrawColor(...GOLD).setLineWidth(0.4);
    pdf.roundedRect(M, y - 4, W, 36, 2, 2, 'FD');
    // QR
    try {
      const qrUrl = qrCanvasDataURL(qrTarget, 200);
      pdf.addImage(qrUrl, 'PNG', PW - M - 26, y - 2, 24, 24);
    } catch (e) {}
    // Text
    pdf.setFont('helvetica', 'bold').setFontSize(8).setTextColor(...BRAND);
    pdf.text('ACTINOVO · MIKRONÄHRSTOFF-MANUFAKTUR HAMBURG', M + 3, y);
    y += 4.5;
    pdf.setFont('helvetica', 'normal').setFontSize(8.8).setTextColor(...INK_SOFT);
    const acTxt = 'Für die in diesem Briefing genannten Mikronährstoffe bietet ActiNovo ' +
      'liposomale Formulierungen mit erhöhter Bioverfügbarkeit. ' +
      (state.praxisName ? 'Empfohlen durch ' + state.praxisName + '.' : 'Empfohlen durch Ihre Berater:in.');
    const acLines = pdf.splitTextToSize(acTxt, W - 32);
    for (const line of acLines) { pdf.text(line, M + 3, y); y += 3.8; }
    // Rabatt-Hinweis als Highlight-Zeile
    pdf.setFont('helvetica', 'bold').setFontSize(9).setTextColor(...BRAND);
    pdf.text('15 % Erst-Rabatt — Code: Ernährung15', M + 3, y + 1.5);
    y += 5;
    pdf.setFont('helvetica', 'normal').setFontSize(7.5).setTextColor(...INK_MUTE);
    pdf.text('actinovo.com — QR scannen oder Code im Checkout eingeben', M + 3, y + 1);
    y += 12;
  }

  /* ── FOOTER ── */
  y += 4;
  pdf.setDrawColor(220).setLineWidth(0.2); pdf.line(M, y, PW - M, y);
  y += 4;
  pdf.setFont('helvetica', 'normal').setFontSize(7.5).setTextColor(...INK_MUTE);
  const disclaimer = pdf.splitTextToSize(DATA._meta.disclaimer, W);
  for (const line of disclaimer) {
    need(3.5);
    pdf.text(line, M, y); y += 3;
  }
  y += 2;
  const sources = 'Quellen: ' + DATA.sources.slice(0, 4).map(s => s.label).join(' · ');
  const srcLines = pdf.splitTextToSize(sources, W);
  for (const line of srcLines) {
    need(3.5);
    pdf.text(line, M, y); y += 3;
  }
  y += 2;
  pdf.setFontSize(7).setTextColor(...INK_MUTE);
  pdf.text('Erstellt mit dem ActiNovo Ernährungsberater-Tool · ' + dateLong(), M, y);

  const fname = `mikronaehrstoff-briefing-${slugify(state.klientin || state.phase)}.pdf`;
  pdf.save(fname);
}

/* ============ HTML-DOWNLOAD ============ */
function downloadHtml() {
  if (!state.phase) return;
  track('html_generated', { phase: state.phase, modifier_count: activeModifiers().length });

  const { phase, mods, merged } = buildMergedData();
  const labels = DATA.nutrient_labels;
  const slug = slugify(state.praxisName);

  const nutHtml = Object.entries(merged).map(([k, n]) => {
    return `<div class="nutrient ${n.level === 'hoch' ? 'lvl-hoch' : 'lvl-mod'}">
      <div class="nut-head">
        <strong>${escapeHtml(labels[k] || k)}</strong>
        <span class="nut-amount">${escapeHtml(n.amount || '')}</span>
      </div>
      <div class="nut-reason">${escapeHtml(n.reason || '')}</div>
      ${n.food_sources && n.food_sources.length ? `<div class="nut-food">Lebensmittel: ${n.food_sources.map(escapeHtml).join(' · ')}</div>` : ''}
    </div>`;
  }).join('');

  const modHtml = mods.length ? `
    <h2>Situationsbedingte Hinweise</h2>
    ${mods.map(m => {
      const mo = DATA.modifiers[m];
      return `<div class="modifier"><strong>${escapeHtml(mo.label)}</strong>${escapeHtml(mo.note || '')}</div>`;
    }).join('')}` : '';

  const html = `<!DOCTYPE html>
<html lang="de"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1">
<title>Mikronährstoff-Briefing · ${escapeHtml(phase.label)}${state.klientin ? ' · ' + escapeHtml(state.klientin) : ''}</title>
<style>
  body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; color: #15211B; background: #FAFAF7; max-width: 720px; margin: 0 auto; padding: 32px 24px; line-height: 1.5; }
  .head { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #003087; padding-bottom: 14px; margin-bottom: 22px; }
  .head img { max-height: 56px; max-width: 200px; }
  .praxis { text-align: right; font-size: 13px; color: #4A5650; }
  .praxis strong { color: #15211B; }
  h1 { color: #003087; font-size: 26px; margin: 8px 0 4px; }
  .phase-label { font-size: 16px; color: #15211B; margin: 0; }
  .meta { color: #7B8780; font-size: 13px; margin: 8px 0 24px; }
  h2 { color: #003087; font-size: 12px; text-transform: uppercase; letter-spacing: 0.08em; margin: 24px 0 8px; border-bottom: 1px solid #DDE3DC; padding-bottom: 4px; }
  .nutrient { border-left: 3px solid #7fcdf2; padding: 8px 0 8px 14px; margin: 6px 0; }
  .nutrient.lvl-hoch { border-left-color: #003087; }
  .nut-head { display: flex; justify-content: space-between; gap: 16px; font-size: 14px; align-items: baseline; }
  .nut-head strong { color: #15211B; }
  .nut-amount { color: #003087; font-size: 13px; }
  .nut-reason { font-size: 12.5px; color: #4A5650; margin-top: 3px; }
  .nut-food { font-size: 11.5px; color: #7B8780; margin-top: 3px; }
  .modifier { background: #e8edf2; padding: 12px 14px; border-radius: 6px; margin: 6px 0; font-size: 13px; color: #4A5650; }
  .modifier strong { display: block; color: #003087; font-size: 12px; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 4px; }
  .note { font-style: italic; color: #4A5650; font-size: 13px; }
  .actinovo { background: #f0f5fa; border: 1px solid rgba(127,205,242,.4); border-radius: 6px; padding: 14px 16px; margin-top: 24px; font-size: 12px; color: #4A5650; }
  .actinovo strong { display: block; color: #003087; font-size: 10px; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 6px; }
  .footer { font-size: 10.5px; color: #7B8780; margin-top: 28px; padding-top: 12px; border-top: 1px solid #DDE3DC; }
  .footer p { margin: 4px 0; }
  a { color: #003087; }
  @media print { body { padding: 18mm; max-width: none; } .actinovo { break-inside: avoid; } }
</style>
</head>
<body>
  <div class="head">
    <div>${state.praxisLogo ? `<img src="${state.praxisLogo}">` : `<strong style="color:#003087">Mikronährstoff-Briefing</strong>`}</div>
    <div class="praxis">
      ${state.praxisName ? `<strong>${escapeHtml(state.praxisName)}</strong>` : ''}
      ${state.praxisStadt ? `<br>${escapeHtml(state.praxisStadt)}` : ''}
    </div>
  </div>
  <h1>Mikronährstoff-Briefing</h1>
  <p class="phase-label">${escapeHtml(phase.label)}</p>
  <p class="meta">
    ${state.klientin ? 'Für: <strong>' + escapeHtml(state.klientin) + '</strong>' : ''}
    ${state.alter ? ' · ' + escapeHtml(state.alter) + ' Jahre' : ''}
    ${(state.klientin || state.alter) ? ' · ' : ''}${dateLong()}
  </p>
  <h2>Empfohlene Mikronährstoffe · Tagesbedarf</h2>
  ${nutHtml}
  ${modHtml}
  ${state.kommentar ? `<h2>Notiz der Berater:in</h2><p class="note">${escapeHtml(state.kommentar)}</p>` : ''}
  <div class="actinovo">
    <strong>ActiNovo · Mikronährstoff-Manufaktur Hamburg</strong>
    Für die in diesem Briefing genannten Mikronährstoffe bietet ActiNovo liposomale Formulierungen mit erhöhter Bioverfügbarkeit.
    ${state.praxisName ? 'Empfohlen durch <strong>' + escapeHtml(state.praxisName) + '</strong>.' : 'Empfohlen durch Ihre Berater:in.'}
    <div style="margin-top:8px;padding-top:8px;border-top:1px dashed rgba(0,48,135,.25);">
      <strong style="color:#003087;">15 % Erst-Rabatt — Code: <code style="background:#fff;padding:1px 6px;border-radius:3px;font-family:monospace;">Ernährung15</code></strong><br>
      <a href="https://actinovo.com/discount/Ern%25C3%25A4hrung15?redirect=%2Fcollections%2Fall&utm_source=praxis&utm_medium=html&utm_campaign=erb-tool&utm_content=${encodeURIComponent(slug)}">Direkt einlösen auf actinovo.com</a>
    </div>
  </div>
  <div class="footer">
    <p>${escapeHtml(DATA._meta.disclaimer)}</p>
    <p><strong>Quellen:</strong> ${DATA.sources.slice(0, 4).map(s => `<a href="${escapeHtml(s.url)}">${escapeHtml(s.label)}</a>`).join(' · ')}</p>
    <p>Erstellt mit dem ActiNovo Ernährungsberater-Tool · ${dateLong()}</p>
  </div>
</body></html>`;

  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = `mikronaehrstoff-briefing-${slugify(state.klientin || state.phase)}.html`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function resetAll() {
  track('tool_reset', {});
  state.gender = null; state.phase = null; state.form = 'misch'; state.reduction = null;
  state.modifiers.clear();
  state.praxisName = ''; state.praxisStadt = ''; state.praxisLogo = null;
  state.klientin = ''; state.alter = ''; state.kommentar = '';
  document.querySelectorAll('input, textarea').forEach(el => { if (el.type !== 'file') el.value = ''; });
  document.querySelectorAll('.chip').forEach(c => c.classList.remove('active'));
  document.querySelector('#formChips .chip[data-form="misch"]').classList.add('active');
  document.querySelector('#erbLogo').value = '';
  $('phaseStep').style.display = 'none';
  $('phaseChips').innerHTML = '';
  applyGenderFilter();
  renderPreview();
}

/* ============ INIT ============ */
(async function init() {
  track('tool_started', {});
  await loadData();
  wireGenderChips();
  wireChipGroup('formChips', 'form', { multi: false });
  wireChipGroup('reductionChips', 'reduction', { multi: false });
  wireChipGroup('metabolicChips', null, { multi: true });
  wireChipGroup('generalChips', null, { multi: true });
  wireInputs();
  $('downloadPdfBtn').addEventListener('click', downloadPdf);
  $('downloadHtmlBtn').addEventListener('click', downloadHtml);
  $('resetBtn').addEventListener('click', resetAll);
  $('disclaimer').textContent = DATA._meta.disclaimer;
  renderPreview();
})();